import React from 'react';
import "./EcosystemPage.scss";
import { ReactComponent as TriangleSvg } from '../../assets/images/ecosystem/triangle.svg';
import { ReactComponent as BlurTriangleSvg } from '../../assets/images/ecosystem/blur-triangle.svg';
import { ReactComponent as CircleSvg } from '../../assets/images/ecosystem/circle.svg';
import { ReactComponent as CircleBlurSvg } from '../../assets/images/ecosystem/circle-blur.svg';
import { ReactComponent as NereusSvg } from '../../assets/images/ecosystem/nereus.svg';
import { ReactComponent as NereusBlurSvg } from '../../assets/images/ecosystem/nereus-blur.svg';
import { ReactComponent as EarnTopSvg } from '../../assets/images/ecosystem/earn-top.svg';
import { ReactComponent as EarnBlurSvg } from '../../assets/images/ecosystem/earn-blur.svg';
import { ReactComponent as DefiLlamaSvg } from '../../assets/images/ecosystem/defi-llama.svg';
import { ReactComponent as DefiLlamaBlurSvg } from '../../assets/images/ecosystem/defi-llama-blur.svg';
import { ReactComponent as OvalBlur } from '../../assets/images/ecosystem/oval-blur.svg';

const EcosystemPage = () => {


    return (
        <div className="EcosystemPage content-container justify-start flex-col">
            <div className="EcosystemPage__titleContainer">
                <h2 className="EcosystemPage__title nereus-color-main">Ecosystem</h2>
                <p className="nereus-color-neutral-grey nereus-callout">Explore dedicated websites, protocol updates, and the
                    administration of the deployed ecosystem.</p>
            </div>

            <div className="EcosystemPage__cardsContainers">
                <a href="https://app.nereus.finance" target="_blank" rel="noopener noreferrer"
                   className="card-container pl-4  py-5 relative EcosystemPage__cardBorrow">
                    <OvalBlur className="EcosystemPage__radialBlur" />
                    <h3 className="nereus-body-m nereus-color-white mb-1.5">Lending/Borrowing</h3>
                    <p className="nereus-callout nereus-color-neutral-grey nereus-callout">Seamlessly borrow or lend funds within a trusted platform
                        for personalized financial growth and
                        opportunities.
                    </p>
                    <TriangleSvg className="EcosystemPage__cardBorrow__icon"/>
                    <BlurTriangleSvg className="EcosystemPage__blurIcon" />
                </a>

                <a href="https://nxusd.nereus.finance" target="_blank" rel="noopener noreferrer"
                   className="card-container pl-4 py-5 relative EcosystemPage__cardStablecoin">
                    <OvalBlur className="EcosystemPage__radialBlur" />
                    <h3 className="nereus-body-m nereus-color-white mb-1.5">NXUSD Stablecoin</h3>
                    <p className="nereus-color-neutral-grey nereus-callout">Borrow NXUSD Stablecoin against your crypto at 0% APR
                    </p>
                    <CircleSvg className="EcosystemPage__cardStablecoin__icon1" />
                    <CircleSvg className="EcosystemPage__cardStablecoin__icon2" />
                    <CircleBlurSvg className="EcosystemPage__blurIcon" />
                </a>

                <a href="https://app.nereus.finance/#/staking" target="_blank" rel="noopener noreferrer"
                   className="card-container pl-4 py-5 relative EcosystemPage__cardStaking">
                    <OvalBlur className="EcosystemPage__radialBlur" />
                    <h3 className="nereus-body-m nereus-color-white mb-1.5">LP Tokens Staking</h3>
                    <p className="nereus-color-neutral-grey nereus-callout">Earn highly lucrative APY in WXT, when you stake Curve LP
                        tokens in th Nereus Protocol
                    </p>
                    <NereusSvg className="EcosystemPage__cardStaking__icon"/>
                    <NereusBlurSvg className="EcosystemPage__blurIcon"/>
                </a>

                <a href="https://nxusd.nereus.finance/stake" target="_blank" rel="noopener noreferrer"
                   className="card-container pl-4 py-5 relative EcosystemPage__cardEarn">
                    <OvalBlur className="EcosystemPage__radialBlur" />
                    <h3 className="nereus-body-m nereus-color-white mb-1.5">NXUSD Earn</h3>
                    <p className="nereus-color-neutral-grey nereus-callout">Earn up to 16% in Stablecoin, when you stake NXUSD in the
                        Nereus Protocol
                    </p>
                    <CircleSvg className="EcosystemPage__cardEarn__icon1" />
                    <CircleSvg className="EcosystemPage__cardEarn__icon2" />
                    <CircleSvg className="EcosystemPage__cardEarn__icon3" />
                    <EarnTopSvg className="EcosystemPage__cardEarn__icon4" />
                    <EarnBlurSvg className="EcosystemPage__blurIcon" />
                </a>

            </div>
            <div className="EcosystemPage__titleContainer">
                <h2 className="EcosystemPage__title nereus-color-main">Protocol metrics</h2>
                <p className="nereus-color-neutral-grey nereus-callout">Websites featuring metrics for the platform protocol</p>
            </div>

            <div className="EcosystemPage__cardsContainers">
                <a href="https://nereus.finance" target="_blank" rel="noopener noreferrer"
                   className="card-container pl-4 py-5 relative EcosystemPage__cardDefi">
                    <OvalBlur className="EcosystemPage__radialBlur" />
                    <h3 className="nereus-body-m nereus-color-white mb-1.5">DeFiLlama</h3>
                    <p className="nereus-color-neutral-grey nereus-callout">Seamlessly borrow or lend funds within a trusted platform
                        for personalized financial growth and
                        opportunities.
                    </p>
                    <DefiLlamaSvg className="EcosystemPage__cardDefi__icon" />
                    <DefiLlamaBlurSvg className="EcosystemPage__blurIcon" />
                </a>
            </div>
        </div>
    );
}

export default EcosystemPage;